var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDobYear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.71094,
    y: 3.65625,
    width: 16.5856,
    height: 16.5856,
    rx: 2.11724,
    fill: "#3158F2",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 16.5H14.0039",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0039 9H14.0039",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 7V11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.43808 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43808 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5553 2V3.65856V2Z",
    fill: "#3158F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5553 2V3.65856",
    stroke: "#3158F2",
    strokeWidth: 1.65856,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDobYear);
export default __webpack_public_path__ + "static/media/dob-year.708e95e07c11823f67a9bcfa16b07e05.svg";
export { ForwardRef as ReactComponent };